import React from 'react'
import arrows from '../../../src/assets/images/mo_icon/mo_arrow_left.svg'
import Refresh_icon from '../../../src/assets/images/icons/refresh_button.svg'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { withTranslation } from "react-i18next";



import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../helpers/global_helper";
import InfiniteScroll from "react-infinite-scroll-component";
import { formatPrice } from "../NumberFormat";
 



const CoinRewardMoDesign = (props) => {

  const Navigate = useNavigate()

  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isItems, setIsitems] = useState(false);

  useEffect(() => {
    fetchRewardData();
  }, [])


  const fetchRewardData = () => {
    let reqData = {
      page: page,
    };
    makeAjax(url.PLAYER_API.getCoinReward, reqData, url.PLAYER_MS_EXT).then((response) => {

      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage("server error No data find", "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      const newData = response.data.reward.data; // Assuming your API returns an array of items
      setItems([...newData]);
      setHasMore(newData.length > 0);
    });
  };
  const handleRefreshBalance = () => {
    setIsitems(true);
    fetchRewardData();
    setTimeout(() => {
      setIsitems(false);
    }, 2000); // 2000 milliseconds = 2 seconds
  };


  const cashOutApiHandle = (id, game_id, coin) => {
    let reqData = {
      id: id,
      gameId: game_id
    };

    makeAjax(url.PLAYER_API.updateReward, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(props.t('internal_err'));
          return;
        }
        showMessage(props.t('trouble_balance'));
        return;
      }
      const cashOutMsg = props.t("cash_out_coin");
      const words = cashOutMsg.split(" ");
      const updatedWords = words.map(word => {
        if (!isNaN(parseInt(word))) {
          return coin.toString();
        } else {
          return word;
        }
      });

      const updatedMsg = updatedWords.join(" ");
      showMessage(updatedMsg, "success", "success")
      fetchRewardData();
      return
    });
  }

  return (
    <div className='mo_coinreward'>
      <div className='mo_pages_topbar'>
        <div className='back_arrow' onClick={() => Navigate("/")}>
          <img src={arrows}></img>
        </div>
        <div className='mo_page_heading'>
          <h2>{props.t("coin_reward")}</h2>

        </div>
      </div>
      <InfiniteScroll
        dataLength={items.length}
        next={() => fetchRewardData()}
        hasMore={hasMore}
        // loader={<h4 className="ladtext">Loading...</h4>}
        endMessage={<p className='text-center'>{props.t("data_not_found")}</p>}
        scrollThreshold={0.7}
        height={"100vh"}
      >
        <table class="table_data">
          <thead>
            <tr>
              <th>{props.t("game")}
              </th>
              <th>{props.t("coin")}
              </th>
              <th>{props.t("expired")}
              </th>
              <th>{props.t("remaining_period")}
              </th>
              <th>{props.t("remaining_turnover")}
              </th>
              <th><img src={Refresh_icon} alt='' className={`coin_refresh ${isItems ? "coin_refresh_ani" : ""}`} onClick={handleRefreshBalance} />

              </th>
            </tr>
          </thead>
          <tbody>
            {items &&
              items.map((reward, index) => {
                const isPeriodZero = parseFloat(reward.period) === 0;
                const isTurnOverZero = parseFloat(reward.turnover) === 0;
                const isCoinZero = parseFloat(reward.coin) !== 0;

                const isButtonEnabled = isPeriodZero && isTurnOverZero && isCoinZero;
                return (
                  <tr
                    key={index}
                  >
                    <td  >{reward.game_name}</td>
                    <td  >{formatPrice(reward.coin)}</td>
                    <td  >{reward.expired}</td>
                    <td  >{isPeriodZero ? "Achieved" : reward.period}</td>
                    <td  >{isTurnOverZero ? "Achieved" : formatPrice(reward.turnover)}</td>
                    <td className='reward'>
                      <button disabled={!isButtonEnabled} onClick={() => cashOutApiHandle(reward.id, reward.game_id, reward.coin)} className='cash-out-btn'>CASH OUT</button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  )
}

export default withTranslation()(CoinRewardMoDesign)